<template>
  <div class="card has-shadow has-border">
    <header class="card-header">
      <p class="card-header-title">{{ title }}</p>
    </header>
    <div class="card-content">
      <div v-if="chartData && chartData.series && chartData.series.length > 0">
        <DonutChart
          :series="chartData.series"
          :labels="chartData.labels"
          :colors="colors"
          :total-label="totalLabel"
          legend-position="right"
        />
      </div>
      <TableEmpty v-else text="No data found" size="small" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockCompareChartCard',
  props: {
    title: {
      type: String,
      required: true
    },
    chartData: {
      type: Object,
      default: null
    },
    colors: {
      type: Array,
      default: () => []
    },
    totalLabel: {
      type: String,
      default: ''
    }
  },
  components: {
    DonutChart: () => import('core/components/graph/DonutChart'),
    TableEmpty: () => import('core/components/TableEmpty')
  }
}
</script>

<style scoped>
.card.has-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card.has-border {
  border: 2px solid rgb(228, 228, 228);
}
</style>
